import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import style from './RemoteOralExam.scss';
import QuestionDisplayContainer from '../question/QuestionDisplay';
import NotesInput from './NotesInput';
import settingsReader from '../../store/readHelpers/SettingsReader';
import remoteOralExamService from '../../services/RemoteOralExamService';
import RemoteOralExamConstants from '../../constants/RemoteOralExamConstants';

const Topic = ({ questionId }) => {
    const onQuestionReady = () => {};
    const [isReadyToAnnounce, setIsReadyToAnnounce] = React.useState(false);

    if (questionId) {
        useEffect(() => {
            remoteOralExamService.sendDisplayStatusAcknowledge(RemoteOralExamConstants.contextDisplayStatus.CONTEXT_DISPLAY_ACK);
            return () => {
                remoteOralExamService.sendDisplayStatusAcknowledge(RemoteOralExamConstants.contextDisplayStatus.CONTEXT_HIDE_ACK);
            };
        }, []);
    }

     useEffect(() => {
        setIsReadyToAnnounce(false);

        if (!questionId) {
            return undefined;
        }

        const timeoutId = setTimeout(() => {
            setIsReadyToAnnounce(true);
        }, 100);

        return () => clearTimeout(timeoutId);
    }, [questionId]);

    return (<div key={questionId} role="alert" aria-live="assertive" aria-atomic="true" className={style.topicContainer}>
        { questionId && isReadyToAnnounce && <QuestionDisplayContainer
            contentRevisionId={questionId}
            onReady={onQuestionReady}
        />
        }
        { /* aria-live="off" opts this subtree out of the ancestor live region, so typing here doesn't re-trigger JAWS re-announcement */ }
        { settingsReader.allowCandidateTakeNotesDuringRemoteOralExam() &&
            <div aria-live="off">
                <NotesInput />
            </div>
        }
    </div>);
};

Topic.propTypes = {
    questionId: PropTypes.number,
};

export default Topic;
